import { render, staticRenderFns } from "./addplayerdialog.vue?vue&type=template&id=0a1b2de8&"
import script from "./addplayerdialog.vue?vue&type=script&lang=js&"
export * from "./addplayerdialog.vue?vue&type=script&lang=js&"
import style0 from "./addplayerdialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports